import React from 'react';
import { NavLink } from 'react-router-dom';

const AboutMeNav = () => (
  <div className="AboutMeNav">
    <nav>
      <ul>
        <li><NavLink activeClassName="active" to="/">Bio</NavLink></li>
        <li><NavLink to="/education">Education</NavLink></li>
        <li><NavLink to="/resume">Experience</NavLink></li>
      </ul>
    </nav>
  </div>
);

export default AboutMeNav;
